<template>
  <div class="login-bg">
    <div class="login-left">
      <img v-if="$store.state.clientele.imageAddress" :src="$store.state.clientele.imageAddress" alt=""/>
      <img v-else src="../../../static/images/logo-white.png" alt=""/>
      <div class="clienteleName" >{{$store.state.clientele.clienteleName}}</div>
      <div class="login-copyright">Copyright 2019 长春市把手科技有限公司</div>
      <div class="login-info">
        <div class="login-info-title">{{$store.state.clientele.displayName}}</div>
        <div class="login-info-text">{{$store.state.clientele.slogan}}</div>
      </div>
    </div>
    <div class="login-right">
      <div class="login-box">
        <h2>重置密码</h2>
        <a-form :form="form">
          <a-form-item
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <a-input class="border-bottom" ref="phone"
                     v-decorator="['phone',{rules: [{ required: true, message: '请输入手机号' }]}]"
                     placeholder="请输入手机号" autocomplete="off"
            />
          </a-form-item>
          <a-form-item class="form-item"
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <a-input class="border-bottom" ref="phoneCode"
                     v-decorator="['phoneCode',{rules: [{ required: true, message: '请输入短信验证码' }]}]"
                     placeholder="请输入短信验证码" autocomplete="off"
            />
            <a-button type="primary" size='small' @click="getPhoneCode" :disabled="disabled">
              获取验证码
            </a-button>
          </a-form-item>
          <a-form-item
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <a-input class="border-bottom" ref="password" type="password"
                     v-decorator="['password',{rules: [{ required: true, message: '请输入新密码' },{ pattern: regNumberEndLetter, message: '请输入数字或字母'}]}]"
                     placeholder="请输入密码" autocomplete="new-password"
            />
          </a-form-item>
          <a-form-item
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <a-input class="border-bottom" ref="confirmPassword" type="password"
                     v-decorator="['confirmPassword',{ rules: [{ required: true, message: '请确认密码' },{validator:this.checkContent.bind(this)}] },]"
                     placeholder="请确认密码" autocomplete="new-password"
            />
          </a-form-item>
          <a-form-item class="margin-top-30"
                       :label-col="formItemLayout.labelCol"
                       :wrapper-col="formItemLayout.wrapperCol"
          >
            <a-button type="default" class="my-btn" @click="toLogin">
              去登录
            </a-button>
            <a-button type="primary" class="my-btn fr" @click="check">
              重置密码
            </a-button>
          </a-form-item>
        </a-form>
      </div>
    </div>
  </div>
</template>

<script>
import md5 from "js-md5";
import { apiListPC } from "@/api";
import ajax from "@/api/ajax";
import { REGEXP_NUMBER_END_LETTER, REGEXP_PHONE } from "@/utils/public/RegExp";
const formItemLayout = {
    wrapperCol: { span: 24, offset: 0 },
};
export default {
    name: "Reset",
    data() {
        return {
            formItemLayout,
            form: this.$form.createForm(this),
            disabled: false,
            timer: null,
            regNumberEndLetter: REGEXP_NUMBER_END_LETTER,
        };
    },
    methods: {
        check() {
            let that = this;
            this.form.validateFields((err) => {
                if (!err) {
                    let sendData = {
                        password: md5(that.$refs.password.value).toUpperCase(),
                        phone: that.$refs.phone.value,
                        license: that.$store.state.license,
                    };
                    ajax(`${apiListPC.resetPassword}?code=${that.$refs.phoneCode.value}`, sendData, "POST")
                        .then(function () {
                            that.$message.success("重置成功，请登录！");
                            that.$router.replace("/Login");
                        })
                        .catch(function (err) {
                            that.$message.error(err.returnInfo);
                        });
                }
            });
        },
        toLogin() {
            this.$router.replace("/Login");
        },
        checkContent(rule, value, callBack) {
            if (value !== this.$refs.password.value) {
                callBack("两次密码输入不一致");
            }
            callBack();
        },
        getPhoneCode(el) {
            let that = this;
            //判断手机号
            let phone = this.$refs.phone.value;
            let reg = REGEXP_PHONE;
            if (!reg.test(phone)) {
                this.$message.error("手机号格式错误");
                return;
            }
            this.disabled = true;
            let s = 60;
            this.timer = setInterval(function () {
                el.target.innerText = s + "秒后重新获取";
                s--;
                if (s == 0) {
                    that.disabled = false;
                    el.target.innerText = "获取验证码";
                    clearInterval(that.timer);
                }
            }, 1000);

            const paramsData = { mobile: phone, license: that.$store.state.license };
            ajax(apiListPC.getResetCaptcha, paramsData)
                .then(function () {})
                .catch(function (data) {
                    if (data.returnInfo === "用户不存在") {
                        that.$message.error("该手机号不存在，请重试！");
                    } else {
                        that.$message.error(data.returnInfo);
                    }
                });
        },
    },
    beforeDestroy() {
        clearInterval(this.timer);
    },
};
</script>

<style lang="less" type="text/less" scoped>
.login-bg {
    width: 100%;
    height: 100vh;

    .login-left {
        width: 605px;
        height: 100%;
        background: url("../../../static/images/bg-4.jpg");
        float: left;
        position: relative;

        img {
            width: 50px;
            height: 50px;
            position: absolute;
            left: 40px;
            top: 40px;
        }

        .clienteleName {
            position: absolute;
            left: 100px;
            top: 40px;
            line-height: 50px;
            color: white;
            font-size: 24px;
        }

        .login-copyright {
            color: #fff;
            opacity: 0.4;
            font-size: 13px;
            text-align: left;
            text-indent: 40px;
            position: absolute;
            bottom: 30px;
            left: 0;
        }

        .login-info {
            width: 100%;
            height: 100px;
            position: absolute;
            left: 0;
            top: 50%;
            margin-top: -40px;
            padding: 0 40px;
        }

        .login-info-title {
            text-align: left;
            height: 60px;
            line-height: 60px;
            font-size: 30px;
            font-weight: 500;
            color: #fff;
            span {
                display: inline-block;
                border: 1px solid #fff;
                font-size: 14px;
                color: #fff;
                border-radius: 2px;
                line-height: 18px;
                padding: 0 3px;
                margin-left: 10px;
                position: relative;
                top: -2px;
            }
        }

        .login-info-text {
            text-align: right;
            height: 40px;
            line-height: 40px;
            font-size: 16px;
            font-weight: 200;
            color: #fff;
        }
    }

    .login-right {
        width: calc(100% - 605px);
        height: 100%;
        float: right;
        position: relative;

        .login-box {
            width: 450px;
            height: 500px;
            position: absolute;
            top: 50%;
            left: 50%;
            margin-left: -200px;
            margin-top: -250px;
            .ant-form-item {
                margin-bottom: 24px;
            }
            .form-item {
                position: relative;
                button {
                    position: absolute;
                    right: 0;
                    top: -6px;
                }
            }
            h2 {
                text-align: center;
                margin-bottom: 0;
                height: 50px;
                line-height: 50px;
                font-weight: 700;
                letter-spacing: 8px;
            }

            .my-btn {
                border-radius: 15px;
                width: 45%;
                display: inline-block;
                float: left;
            }

            .fr {
                float: right;
            }

            .border-bottom {
                border: none;
                border-bottom: 1px solid #ddd;
                border-radius: 0;
            }

            .margin-top-30 {
                margin-top: 30px;
            }
        }
    }
}
</style>